module.exports = __webpack_public_path__ + "static/img/mkg.6dcf899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/mkg.png
// module id = DW2v
// module chunks = 0